import React from "react";
import { expiryStatus, formatExpiryDateTime } from "../../utils/expiry";
import "./index.css";

/**
 * Expiry date with a coloured status pill underneath:
 *   red    "Expired 2 days ago"
 *   amber  "Expires Today"
 *   green  "5 Days Left"
 * Replaces the old whole-row / whole-cell green-red background.
 */
const ExpiryDate = ({ value }) => {
  const status = expiryStatus(value);
  if (!status) return <span className="expiry-date__none">N/A</span>;
  return (
    <span className="expiry-date">
      <span className="expiry-date__value">{formatExpiryDateTime(value)}</span>
      <span className={`expiry-pill expiry-pill--${status.tone}`}>{status.text}</span>
    </span>
  );
};

export default ExpiryDate;
